import {Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ChargingMethodologyModel} from '../../../../models/ChargingMethodologyModel';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';
import {Component} from '@angular/core';

@Component({
  selector: 'app-charging-methodology-filter',
  templateUrl: './charging-methodology-filter.component.html',
  styleUrls: ['./charging-methodology-filter.component.scss']
})
export class ChargingMethodologyFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listChargingFilter: any[];

  @Input() chargingMethData: any;
  @Input() chargingMethSelected: ChargingMethodologyModel;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('chargingMethData' in changes) {
      this.listChargingFilter = this.chargingMethData ? this.chargingMethData : [];
    }
    if (this.chargingMethSelected) {
      this.optionSelected = this.chargingMethSelected;
    }
  }

  public getElementSelected(): void {
    this.dataFiltered.emit(this.optionSelected.value);
  }

  ngOnDestroy(): void {
  }

  public compareObjects(o1: any, o2: any) {
    if (o2 === undefined || o2 ===  null) {
      return false;
    }
    return o1.value === o2.value;
  }

}
